// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".title-col[data-v-113be91c] {\n  font-size: 24px;\n}\n.page-col[data-v-113be91c] {\n  font-size: 14px;\n  text-align: center;\n}\n.margin-top-8[data-v-113be91c] {\n  margin-top: 8px;\n}\n.col-style[data-v-113be91c] {\n  font-size: 14px;\n  margin-top: 20px;\n}\n.left-20-top-8[data-v-113be91c] {\n  margin-left: 20px;\n  margin-top: 8px;\n}\n", ""]);
// Exports
module.exports = exports;
